/**
 * Throws an error if value is null, undefined or empty string.
 * @param value
 * @param msg Error message
 */
export function assert<T>(
  value: T,
  msg?: string,
): asserts value is Exclude<T, null | undefined | ""> {
  if (value === null || value === undefined || value === "") {
    throw new Error(
      msg ?? `Expected ${value} to defined and not an empty string`,
    );
  }
}
